import type { SchemaChatResolver_GetInboxUnreadSummary } from 'cpool-tables/backend-resolvers';

export function unreadByChatIdFromSummary(
    summary: SchemaChatResolver_GetInboxUnreadSummary | undefined,
): Map<string, number> {
    const entries = [
        ...(summary?.byLoanRequest.flatMap((group) => group.chats) ?? []),
        ...(summary?.partner ?? []),
        ...(summary?.unlinked ?? []),
    ];
    return new Map(entries.map((chat) => [chat.chatId, chat.unreadCount]));
}
